export function isPdfFile(item: { content_type?: string | null; name?: string | null }): boolean {
  const type = (item.content_type || "").toLowerCase();
  const name = (item.name || "").toLowerCase();
  return type.includes("pdf") || name.endsWith(".pdf");
}

export function pickInvoiceAttachment<
  T extends { id?: string | null; content_type?: string | null; name?: string | null; size?: number | null },
>(items: T[]): T | null {
  const pdfs = items.filter((item) => item.id && isPdfFile(item));
  if (pdfs.length > 0) {
    return [...pdfs].sort((a, b) => attachmentScore(b) - attachmentScore(a))[0] ?? null;
  }
  return (
    items.find((item) => item.id && (item.content_type || "").toLowerCase().startsWith("image/")) ||
    items.find((item) => item.id) ||
    null
  );
}

function attachmentScore(item: { name?: string | null; size?: number | null }): number {
  const name = (item.name || "").toLowerCase();
  let score = 0;
  if (
    name.includes("rechnung") ||
    name.includes("invoice") ||
    name.includes("faktura") ||
    name.includes("gutschrift")
  ) {
    score += 10;
  }
  if (name.includes("agb") || name.includes("bedingungen") || name.includes("angebot")) score -= 5;
  score += Math.min(Number(item.size || 0) / 100_000, 4);
  return score;
}
